// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3aGyW","tab":"ProcedureTabs_tab__3amj7"};